// apps/client/src/pages/leads/edm/components/BulkTagBar.tsx
//
// Shown while contacts are selected: add or remove one tag on every selected
// contact (edmContactAction bulkTag, at most 500 ids per call).

import React, { useState } from 'react';
import { Tags, X } from 'lucide-react';
import type { EdmTagEntry } from '../../../../hooks/useEdmContacts';
import { EDM_UI } from '../../../../utils/edm';

interface Props {
  selectedCount: number;
  tags: EdmTagEntry[];
  busy: boolean;
  onApply: (add: string[], remove: string[]) => void;
  onClear: () => void;
}

const BulkTagBar: React.FC<Props> = ({ selectedCount, tags, busy, onApply, onClear }) => {
  const [tag, setTag] = useState('');
  if (selectedCount === 0) return null;
  return (
    <div
      role="region"
      aria-label="Bulk tag"
      className="flex flex-wrap items-center gap-3 rounded-lg border border-blue-500/30 bg-blue-500/10 px-4 py-3"
    >
      <Tags className="h-4 w-4 text-blue-400" />
      <span className="text-sm text-blue-200">{selectedCount.toLocaleString('en-AU')} selected</span>
      <select
        aria-label="Tag to apply"
        className={`${EDM_UI.input} w-auto`}
        value={tag}
        onChange={(e) => setTag(e.target.value)}
      >
        <option value="">Choose a tag</option>
        {tags.map((t) => (
          <option key={t.name} value={t.name}>
            {t.name}
          </option>
        ))}
      </select>
      <button
        type="button"
        className={EDM_UI.secondaryButton}
        disabled={!tag || busy}
        onClick={() => onApply([tag], [])}
      >
        Add tag
      </button>
      <button
        type="button"
        className={EDM_UI.secondaryButton}
        disabled={!tag || busy}
        onClick={() => onApply([], [tag])}
      >
        Remove tag
      </button>
      <button type="button" className={`${EDM_UI.secondaryButton} ml-auto`} onClick={onClear}>
        <X className="h-4 w-4" /> Clear selection
      </button>
    </div>
  );
};

export default BulkTagBar;
